module.exports = __webpack_public_path__ + "components/country-flag/static/mr-9a64ebbc21b20dd02a202e2618146d24.svg";